import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'nym-user-listing-no-results',
  templateUrl: './user-listing-no-results.component.html',
  styleUrls: ['./user-listing-no-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserListingNoResultsComponent implements OnInit {

  @HostBinding('class.nym-user-listing-no-results')
  protected get classes(): boolean { return true; }

  constructor() { }

  public ngOnInit(): void { }

}
